import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';

/**
 * React Hook which measures DOM element attached to ref
 */
var useClientRect = function useClientRect() {
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    rect = _React$useState2[0],
    setRect = _React$useState2[1];
  var ref = React.useCallback(function (node) {
    if (node !== null) {
      setRect(node.getBoundingClientRect());
    }
  }, []);
  return [rect, ref];
};

export { useClientRect };
